<template>
	<div>
		<v-skeleton-loader
			v-if="isLoading"
			v-bind="attrs"
			max-width="555"
			width="100%"
			type="card"
		></v-skeleton-loader>

		<div v-else class="pt-5" style="width: 100%">
			<div class="mb-2" v-for="subItem in subDirectories" :key="subItem.id">
				<DirectorySubItemPreview :subItem="subItem" />
			</div>
		</div>
		<div
			class="d-flex my-9 justify-center home-page__pagination"
			v-if="!isLoading && subDirectories.length > 0"
		>
			<Pagination
				:page="filters.page"
				:pageCount="+this.pageSubDirectories"
				v-on:pageChange="onPageChange"
			/>
		</div>
		<v-dialog
			v-model="emptyList"
			class="exhibitor-page__modal"
			max-width="588px"
			width="100%"
			persistent
		>
			<v-card class="exhibitor-page__modal">
				<div class="exhibitor-page__modal__title">No data available.</div>
				<button @click="closeModal" type="button" class="exhibitor-page__modal__btn">
					OK
				</button>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Filter from '@/mixins/Filter.js'
import Pagination from '@/components/Pagination.vue'
import DirectorySubItemPreview from '@/components/Directory/DirectorySubItemPreview.vue'
export default {
	name: 'DirectorySubItemPage',
	mixins: [Filter],
	components: {
		Pagination,
		DirectorySubItemPreview,
	},
	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			emptyList: false,
		}
	},
	watch: {
		subDirectories(newVal) {
			if (newVal?.length) {
				this.setPageTitle(this.sectionName)
			} else {
				this.emptyList = true
			}
		},
	},
	computed: {
		...mapGetters('directory', ['isLoading', 'subDirectories', 'pageSubDirectories']),
		sectionName() {
			const firstSubItem = this.subDirectories?.[0]
			return firstSubItem?.public?.[0]?.section || ''
		},
	},
	methods: {
		...mapActions('directory', ['getSubDirectories']),
		...mapActions('app', ['setPageTitle']),
		closeModal() {
			this.emptyList = false
			this.$router.go(-1)
		},
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	created() {
		this.getSubDirectories(this.requestQuery)
	},
}
</script>
